export default __webpack_public_path__ + "static/media/shopCategory-2.edb6fdc5.png";